import defaultClient from '@src/api/clients/default';

export function fetchBudgetPacing(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing/',
    payload,
  });
}

export default {
  fetchBudgetPacing,
};
